// extracted by mini-css-extract-plugin
module.exports = {"orgDropdown":"index_orgDropdown_3dCBv","mb10":"index_mb10_OqTsM"};